import type { PropsWithChildren } from "react";
import { SiteShell } from "./site-shell";

interface DocumentPageShellProps extends PropsWithChildren {
	eyebrow: string;
	title: string;
	description: string;
}

export function DocumentPageShell({ eyebrow, title, description, children }: DocumentPageShellProps) {
	return (
		<SiteShell>
			<main className="mx-auto max-w-5xl px-6 pb-24 sm:px-8 lg:px-12">
				<section className="rounded-[2.6rem] border border-white/10 bg-white/5 px-8 py-10 shadow-[0_36px_90px_-56px_rgba(0,0,0,0.76)] backdrop-blur sm:px-10 lg:px-12">
					<p className="text-sm font-semibold uppercase tracking-[0.24em] text-[var(--color-app-accent-secondary)]">{eyebrow}</p>
					<h1 className="mt-4 text-4xl font-semibold tracking-[-0.06em] text-white sm:text-5xl">{title}</h1>
					<p className="mt-5 max-w-3xl text-lg leading-8 text-white/70">{description}</p>
				</section>
				<div className="mt-10 space-y-8">{children}</div>
			</main>
		</SiteShell>
	);
}
